import React from "react";
import moment from "moment";
import classNames from "classnames";
import classes from "./styles.module.scss";
import shieldImage from "../../assets/asset.png";
import Modal from "../../layout/Modal";

export default ({
  textMessage,
  showModal,
  event,
  handleCloseModal,
  handleCloseForm,
}) => {
  return (
    <Modal show={showModal} handleClose={handleCloseModal}>
      <div
        className="modal-dialog modal-dialog-centered modal-sm"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header" style={{ padding: "20px 30px" }}>
            <p
              className="modal-title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              Informasi
            </p>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => handleCloseModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            className="modal-body"
            style={{ padding: "30px", fontSize: "13px" }}
          >
            <div className="mx-auto text-center">
              <img
                src={shieldImage}
                alt="asset"
                style={{ width: "150px", height: "auto" }}
              />
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                Check email anda untuk detail dan link event.
              </p>
              {/* <p style={{fontSize: '15px', fontWeight: '600',marginTop: '10px'}}>{textMessage}</p>
              <p className="text-muted" style={{fontSize: '12px', margin: '20px 0px'}}>{event.title}  {moment(event.startDate).format('ddd, MMMM DD')}, {event.startTime}</p> */}
              <button
                type="button"
                className={classNames("btn mt-2 p-2", classes.btnJoin)}
                onClick={()=>{handleCloseForm(); handleCloseModal()}}
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
